import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

// CONSTANTS
import colors from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const TitleContainer = styled.div`
  margin-bottom: 35px;

  span {
    font-size: 2.4rem;
    color: ${colors.textSecondary};
  }

  .main-title {
    font-size: 4.5rem;
    line-height: 4.7rem;

    ${breakpoints.down('xs')} {
      font-size: 3.5rem;
      line-height: 3.7rem;
    }
  }

  .title-second {
    margin-top: 60px;
    font-size: 2.4rem;

    ${breakpoints.down('xs')} {
      margin-top: 40px;
    }
  }
`;

export const Title = styled(Typography)`
  margin-bottom: 15px;

  &.required::after {
    content: '*';
    margin-left: 5px;
    color: ${colors.error};
  }
`;
